import { render, staticRenderFns } from "./markScore.vue?vue&type=template&id=45691b1c&scoped=true&"
import script from "./markScore.vue?vue&type=script&lang=js&"
export * from "./markScore.vue?vue&type=script&lang=js&"
import style0 from "./markScore.vue?vue&type=style&index=0&id=45691b1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45691b1c",
  null
  
)

export default component.exports